import { VEHICLE_FUEL_TYPES } from 'Utilities/consts';

import { ALLOWED_BATTERY_OWNERSHIP_VEHICLES } from './SpecificationSection.const';

type ShouldEnableBatteryOwnershipArgs = {
	fuel: string;
	make: string;
	model: string;
};

export const shouldEnableBatteryOwnership = ({ fuel, make, model }: ShouldEnableBatteryOwnershipArgs): boolean => {
	const vehicleMake = make?.toLowerCase();
	const vehicleModel = model?.toLowerCase();
	const isEVVehicle = VEHICLE_FUEL_TYPES.ELECTRIC.toLowerCase() === fuel?.toLowerCase();

	if (!isEVVehicle) {
		return false;
	}

	return ALLOWED_BATTERY_OWNERSHIP_VEHICLES.some(({ allowedMake, allowedModel }) => {
		return allowedMake === vehicleMake && (!allowedModel || vehicleModel.includes(allowedModel));
	});
};
